import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="column-checkbox"
// Handles select all/deselect all functionality for checkbox columns
export default class extends Controller {
  static targets = ["monitoringHeader", "reportingHeader", "monitoring", "reporting"]

  connect() {
    this.updateMonitoringHeader()
    this.updateReportingHeader()
  }

  toggleMonitoring() {
    const checked = this.monitoringHeaderTarget.checked
    this.monitoringTargets.forEach(checkbox => {
      if (!checkbox.disabled) checkbox.checked = checked
    })
  }

  toggleReporting() {
    const checked = this.reportingHeaderTarget.checked
    this.reportingTargets.forEach(checkbox => {
      if (!checkbox.disabled) checkbox.checked = checked
    })
  }

  updateMonitoringHeader() {
    if (!this.hasMonitoringHeaderTarget) return

    const enabledCheckboxes = this.monitoringTargets.filter(cb => !cb.disabled)
    if (enabledCheckboxes.length === 0) return

    const allChecked = enabledCheckboxes.every(cb => cb.checked)
    const someChecked = enabledCheckboxes.some(cb => cb.checked)

    this.monitoringHeaderTarget.checked = allChecked
    this.monitoringHeaderTarget.indeterminate = !allChecked && someChecked
  }

  updateReportingHeader() {
    if (!this.hasReportingHeaderTarget) return

    const enabledCheckboxes = this.reportingTargets.filter(cb => !cb.disabled)
    if (enabledCheckboxes.length === 0) return

    const allChecked = enabledCheckboxes.every(cb => cb.checked)
    const someChecked = enabledCheckboxes.some(cb => cb.checked)

    this.reportingHeaderTarget.checked = allChecked
    this.reportingHeaderTarget.indeterminate = !allChecked && someChecked
  }
}
